/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Link } from "react-router-dom";
import styled from "styled-components";
import { theme } from "@nordcloud/gnui";

export const ButtonTransparent = styled.button`
  background: none;
  border: none;
  border-radius: ${theme.radiusDefault};
  transition: background-color 0.2s ease-in-out;
  padding: calc(0.875rem - 1px) calc(${theme.spacing.spacing03} + 1px);
  cursor: pointer;
  outline: none;
  &:hover {
    background-color: ${theme.color.interactive.secondaryHover};
  }
`;

export const StyledLink = styled(Link)`
  cursor: pointer;
  border-radius: ${theme.radiusDefault};
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease-in-out;
  &:hover {
    background-color: ${theme.color.interactive.secondaryHover};
  }
`;

export const NotificationsListWrapper = styled.ul`
  background-color: ${theme.color.background.ui01};
  border-radius: ${theme.radiusDefault};
  border: solid 1px ${theme.color.background.ui04};
  box-shadow: rgb(31 30 47 / 10%) 12px 0 22px;
  padding: ${theme.spacing.spacing02} ${theme.spacing.spacing04};
`;

export const NotificationItemWrapper = styled.li`
  cursor: default;
  list-style-type: none;
  padding-inline-start: ${theme.spacing.spacing01};

  :not(:last-of-type) {
    padding-bottom: ${theme.spacing.spacing02};
  }

  &.show-all-link {
    padding-top: ${theme.spacing.spacing04};
    text-align: right;
  }
`;
